<template>
        
        <q-modal v-model="uploadDialog"  maximized @escape-key='unlockOrder'>
          <form id="add_form" action="#"  @submit.prevent="saveOrder">
              
            <q-modal-layout>
                <q-toolbar slot="header">
                <q-toolbar-title>
                    Загрузка файлов в облако
                </q-toolbar-title>

                <q-btn
                    color="negative"
                    label="Отмена"
                    icon = "cancel"
                    wait-for-ripple
                    @click="cancelEdit"
                    style="margin-right: 20px;"
                />
                
                <q-btn
                    color="green"
                    label="Загрузить"
                    icon = "save"
                    wait-for-ripple
                    type="submit"
                    :disable = "saveBlock"
                />
                
                </q-toolbar>

                <div class="layout-padding" style="align-items: center;">

                    <div class="row wrap full-width justify-center content-center" style='min-height:30px;'>
                        <q-spinner-facebook color='primary' :size='30' v-if='gettingCloudFiles' />

<!-- показываем список загруженных в облако файлов -->
                        <div v-if='!gettingCloudFiles' class='row full-width justify-center content-center'>
                          
                            <div v-for="(item, key) in cloudFiles" :key="key" style='width:300px' class='file-item q-pa-xs q-body-1 items-center ellipsis'>
                                <div class="row no-wrap items-center">
                                    <q-btn icon='far fa-trash-alt' flat color='red' size='xs' @click='deleteCloudFile(item.key)' />
                                    <a v-bind:href="item.src"><div class='text-black ellipsis' style='width:180px;'>
                                        {{item.key}}
                                        <q-tooltip :delay=500>{{item.key}}</q-tooltip>
                                    </div></a>
                                    <div class='q-ml-md text-faded q-caption'>{{item.size}} mB</div>                                  
                                </div>

                            </div>

                        </div>

                    </div>
                    

                    <div style="width:450px; align-items: center;">
                      
                    </div>
                    
                    <upload></upload>
                    
                </div>
            </q-modal-layout>
           </form>
        </q-modal>

</template>
<script>

/* eslint-disable */
import upload from './cloudUpload';


export default {

  name:'cloudFileUploadDialog',
  
  data () {
            return {
                uploadDialog: false, 
                orderId : 0,  
                saveBlock : false, //флаг блокировки дублирования сохранения
                files : [],
                gettingCloudFiles : false,
            }
  },

  components :{
      upload,
  },
 
  created() {

      eventBus.$on('openCloudUploadDialog', (order)=>{
         this.orderId = order; // номер заказа
         this.uploadDialog = true;
         // и тут получаем список уже загруженных в облако файлов
         this.gettingCloudFiles = true;
         this.$store.dispatch('getCloudFiles', order)
         .then(()=>{
             this.gettingCloudFiles = false;
         })
         .catch((error)=>{
             console.log(error);
         });
      });
  },
  
  beforeDestroy() {
      eventBus.$off('openCloudUploadDialog');
  },

  computed: {
      cloudFiles() {
          return this.$store.getters.getCloudFiles;
      }
  },

  methods : {

        deleteCloudFile(key) {
            this.$store.dispatch('deleteFromCloud', key)
            .then()
            .catch();
        },

        unlockOrder(){

            this.$store.dispatch('unlockOrder',  this.orderId)
            .then()
            .catch(error => {
                this.$admns.showNotify('Не удалось разблокировать запись','error','Сообщение системы');
                console.log(error);
            });

        },

      
      setEmptyData() {
         this.$store.commit('clearUploadFiles'); // очищаем список файлов для загрузки
      },

      showNotify(nMessage, nType, detail='') {

          this.$admns.showNotify(nMessage, nType, detail);

      },


      saveOrder() {

            if (this.saveBlock) return; // значит дублирование сохранения

            let order = this.$store.getters.getOrderById(this.orderId);// получили ордер (т.к. он уже должен существовать к этому моменту)

            if (this.$store.getters.needToCloudUpload) {
                order.fileCloud = 1;
            }

            this.$store.dispatch('updateOrder', order)
            .then( () => {
                this.showNotify('Начинаем загрузку...', 'success')    
                eventBus.$emit('clearPreview'); // удаляем все превью
                this.uploadDialog = false;
                this.saveBlock = false;
            })
            .catch(error => {
                console.log(error);
                this.saveBlock = false;
            });

      },

      cancelEdit() {
          this.uploadDialog = false;
          this.setEmptyData();
          //this.unlockOrder();
          this.showNotify('Отмена загрузки', 'error', '')
      }
  },
  
  

}
</script>

<style lang="scss" scoped>
    .param-container {
        width:350px;
    }
    .drop-container {
        margin-top : 35px;
        padding-top : 130px;
        width : 90%;
        height : 300px;
        border : 1px dashed darkgray;
        font-size : 15px;
        color:darkgray;
        text-align: center;
        align-items: center;
    }
    .file-item {
        border : 1px solid darkgray;
        border-radius: 2px;
        margin:3px;
        background: rgb(217, 242, 253);
    }
    a {
        text-decoration : none;
    }
</style>
